export default "__VITE_ASSET__BErtAN9y__"